import { NCDEmailContent } from '../components/common/CommonTypes';
import { SaveResponse } from '../components/sitePages/insurance/ProofOfNcd';
import { ApiHelper } from './apiHelper';

export class FileUploadApi {
  deleteUpload(filepath: string, callback = null) {
    const deleteUrl = '/api/FileUpload/delete';
    new ApiHelper().deleteData(deleteUrl, filepath, callback);
  }

  uploadFile(upload: string, token: string, callback = null) {
    const postUrl = '/api/FileUpload/upload';
    new ApiHelper().postDataSecureAsync(postUrl, upload, token, callback);
  }

  saveFiles(
    data: NCDEmailContent,
    token: string,
    successCallback: (response: SaveResponse) => void,
    failureCallback: () => void
  ) {
    const postUrl = '/api/FileUpload/saveFiles';
    new ApiHelper().postDataWithResponseSecure(
      postUrl,
      data,
      token,
      successCallback,
      failureCallback
    );
  }
}
